/**
 * Farmer image operations service.
 * Provides async functions for farmer image upload operations.
 */

import { farmerImageUploadApi, ImageUploadPayload } from "model";

/**
 * Upload a farmer image.
 * Returns the guid of the uploaded image.
 */
export async function uploadFarmerImage(
  payload: ImageUploadPayload
): Promise<string> {
  const result = await farmerImageUploadApi.uploadImage(payload);
  return result.guid;
}
